import {
  Environment,
  SleepUtility,
  getDiagnosticsService,
} from '@mchs/web-core';
import {
  CreateUnauthenticatedAppointmentByMHNServiceMock,
  CreateUnauthenticatedAppointmentServiceMock,
  GetAcceptFormatQuestionsServiceMock,
  GetPulseServiceMock,
  GetUnauthenticatedAppointmentSlotsServiceMock,
  GetUnauthenticatedProviderAppointmentTypesServiceMock,
  RecaptchaSiteVerifyServiceMock,
  SendPatientAccessCodeServiceMock,
  VerifyByMHNAndDateOfBirthServiceMock,
  VerifyPatientAccessCodeServiceMock,
} from '../../services';
import {
  CreateUnauthenticatedAppointmentByMHNServiceName,
  CreateUnauthenticatedAppointmentServiceName,
  GetAcceptFormatQuestionsServiceName,
  GetPulseServiceName,
  GetUnauthenticatedAppointmentSlotsServiceName,
  GetUnauthenticatedProviderAppointmentTypesServiceName,
  RecaptchaSiteVerifyServiceName,
  SendPatientAccessCodeServiceName,
  VerifyByMHNAndDateOfBirthServiceName,
  VerifyPatientAccessCodeServiceName,
} from '../serviceConfig';
import { Failure, HttpClient, Result, Success } from './httpClient';

export class MockHttpClient implements HttpClient {
  readonly diagnosticsService = getDiagnosticsService();

  async get(
    url: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    token: string | undefined,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    query?: any
  ): Promise<Result> {
    await this.serviceCallLatency();

    const serviceName = this.getServiceNameFromUrl(url);

    switch (serviceName) {
      case GetPulseServiceName:
        return new Success(GetPulseServiceMock);
      default:
        break;
    }

    // If we're here then we didn't handle the call type and/or address.
    this.diagnosticsService.logError(
      'MockHttpClient',
      `Unhandled url in mock http client get (url: ${url})`
    );
    return new Failure('Unhandled mock get call', false);
  }
  async post(
    url: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    token: string | undefined,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    query?: any
  ): Promise<Result> {
    await this.serviceCallLatency();

    const serviceName = this.getServiceNameFromUrl(url);

    switch (serviceName) {
      case CreateUnauthenticatedAppointmentServiceName:
        return new Success(CreateUnauthenticatedAppointmentServiceMock);
      case CreateUnauthenticatedAppointmentByMHNServiceName:
        return new Success(CreateUnauthenticatedAppointmentByMHNServiceMock);
      case GetAcceptFormatQuestionsServiceName:
        return new Success(GetAcceptFormatQuestionsServiceMock);
      case GetUnauthenticatedAppointmentSlotsServiceName:
        return new Success(GetUnauthenticatedAppointmentSlotsServiceMock);
      case GetUnauthenticatedProviderAppointmentTypesServiceName:
        return new Success(
          GetUnauthenticatedProviderAppointmentTypesServiceMock
        );
      case RecaptchaSiteVerifyServiceName:
        return new Success(RecaptchaSiteVerifyServiceMock);
      case SendPatientAccessCodeServiceName:
        return new Success(SendPatientAccessCodeServiceMock);
      case VerifyByMHNAndDateOfBirthServiceName:
        return new Success(VerifyByMHNAndDateOfBirthServiceMock);
      case VerifyPatientAccessCodeServiceName:
        return new Success(VerifyPatientAccessCodeServiceMock);
      default:
        break;
    }

    // If we're here then we didn't handle the call type and/or address.
    this.diagnosticsService.logError(
      'MockHttpClient',
      `Unhandled url in mock http client post (url: ${url})`
    );
    return new Failure('Unhandled mock post call', false);
  }

  private async serviceCallLatency(): Promise<void> {
    // Check if service latency is turned on.  If so, we'll sleep here
    // for the specified amount of time.
    const latency = Environment.serviceCallLatency();
    if (latency > 0) {
      await SleepUtility.sleepAsync(latency);
    }
  }

  private getServiceNameFromUrl(url: string): string | undefined {
    /* Grab the service name from the end of the passed in URL */
    const splitUrlArray = url.split('/');
    return splitUrlArray.at(splitUrlArray.length - 1);
  }
}
